import {css} from 'lit';
export const styles = css`:host {
  --img-height: 115px;
  --main-padding: 16px;
  --slot-padding: 16px;
  --title-font-size: var(--font-size-md);
  --description-font-size: var(--font-size-sm);

  display: block;
  background-color: var(--contrast-light);
  border-radius: var(--border-radius);
  color: var(--dark-text);
  font-weight: 700;
}

.main-wrapper {
  position: relative;
  display: flex;
  align-items: flex-end;
  height: var(--img-height);
  padding: var(--main-padding);
}

.main-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(
    180deg,
    rgb(var(--contrast-dark-rgb), 0) 0%,
    rgb(var(--contrast-dark-rgb), 0.65) 100%
  );
  z-index: 1;
}

.info {
  display: flex;
  align-items: flex-end;
  color: var(--contrast-light);
  font-size: var(--font-size-sm);
  z-index: 2;
}

.info > *:not(:first-child) {
    margin-left: 10px;
  }

.info .members,
  .info ef-icon {
    padding-bottom: 1px;
  }

.members {
  position: relative;
  font-weight: 600;
  line-height: 1;
  min-width: -webkit-fit-content;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.slot-wrapper {
  padding: var(--slot-padding);
}

a {
  --link-text: var(--dark-text);
  --link-text-hover: var(--dark-text);
  --link-text-active: var(--dark-text);

  display: block;
}

@media (hover: hover) {
  a:hover {
    background-color: var(--gray-200);
  }
}

a:active {
  background-color: var(--contrast-light);
}

img {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -o-object-fit: cover;
     object-fit: cover;
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  z-index: 0;
}

ef-label {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 100;
}

ef-img-placeholder {
  --background-primary: var(--gray-500);
  --text-primary: var(--gray-100);
  --element-size: 60px;
  --font-size-primary: 30px;
}

xs-origin {
  position: relative;
  font-weight: 600;
  word-wrap: break-word;
  transform: translateY(2px);
}

xs-origin:not(:first-child) {
  padding-left: 8px;
}

xs-origin:not(:first-child)::before {
    content: '';
    position: absolute;
    display: inline-block;
    top: 50%;
    left: 0;
    height: 18px;
    width: 1px;
    background-color: var(--contrast-light);
    transform: translateY(-50%);
  }

::slotted(*) {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: var(--title-font-size);
}

::slotted(.xs-title-3) {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

slot[name='desc']::slotted(*) {
  margin-top: 4px;
  font-size: var(--description-font-size);
  color: var(--dark-text-secondary);
  font-weight: 400;
}

:host([layout='lg']) {
  --main-padding: 24px;
  --slot-padding: 24px;
  --img-height: 176px;
  --title-font-size: var(--font-size-lg);
}
`;
export default styles;
